/* eslint-disable promise/param-names */
import {
  SLIDER_REQUEST,
  SLIDER_COMMIT,
  SLIDER_SUCCESS,
} from '@/store/actions/slider';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

import querystring from 'querystring-browser';
import moment from 'moment';

import Vue from 'vue';
import {sleep} from '@/utils/utils.js'

const state = { 
  slider: [],
  status: '',
  hasLoadedOnce: false,
};

const getters = {
  slider: state => state.slider ? state.slider : '',
  sliderLoading: state => state.status == 'loading',
  sliderLoaded: state => { 
    return state.hasLoadedOnce
  }
};

const actions = {
  [SLIDER_REQUEST]: ({commit}) => {
    console.log(SLIDER_REQUEST);

    return new Promise((resolve) => {
      commit(SLIDER_REQUEST)

      firebase.firestore().collection('pages').doc('slider').get()
          .then(documentSnapshot => {
            if (documentSnapshot.exists) {
              commit(SLIDER_SUCCESS, documentSnapshot.data().books);
              resolve(documentSnapshot.data().books);
            }

            commit(SLIDER_SUCCESS);
            resolve('');
          })
    })
  },
 
  [SLIDER_COMMIT]: ({commit}, books) => {
    commit(SLIDER_REQUEST)
    let bookIds = {};
    books.map((el,index) => {bookIds[el.id] = index});

    firebase.firestore().collection('pages').doc('slider').set({
      books: JSON.parse(JSON.stringify(books)),
      bookIds: bookIds
    })
        .then(() => {
          commit(SLIDER_SUCCESS);
        })
  },
}

const mutations = {
  [SLIDER_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [SLIDER_SUCCESS]: (state, slider) => {
    state.status = 'success'

    if (slider !== undefined) {
      state.slider = slider;
      state.hasLoadedOnce = true;
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
